import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PermissionDeniedPage } from './PermissionDeniedPage';
import { useAuth } from '../contexts/AuthContext';

interface PortalAccessDeniedPageProps {
  authPath?: string;
  currentRole?: string | null;
  message?: string;
}

export const PortalAccessDeniedPage: React.FC<PortalAccessDeniedPageProps> = ({
  authPath = '/auth',
  currentRole,
  message = 'Your account does not have access to this application. Go back to try signing in with a different account.',
}) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleRetryLogin = async () => {
    try {
      await signOut();
    } finally {
      void navigate(authPath, { replace: true });
    }
  };

  return (
    <PermissionDeniedPage
      currentRole={currentRole}
      hideHome
      message={message}
      onBack={handleRetryLogin}
    />
  );
};
